<template>
  <div>
    <booking-success
      heading="bookingForm.BookingDetail.yourCreatedBooking"
      text="bookingForm.BookingDetail.yourCreatedBookingText"
      :showDownloadBtn="false"
    />

    <v-row class="justify-center">
      <v-col :cols="isMobile ? '3' : 'auto'">
        <v-btn color="error" outlined elevation="0" :block="isMobile" @click="goToCancel">
          {{ $t("bookingForm.BookingDetail.cancel") }}
        </v-btn>
      </v-col>
      <v-col :cols="isMobile ? '3' : 'auto'">
        <v-btn color="primary" elevation="0" :block="isMobile" @click="goToUpdate">
          {{ $t("bookingForm.BookingDetail.update") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import BookingSuccess from "./BookingSuccess.vue";
import { UserGoToHelper } from "@/lib/utility/user-go-to-helper";

@Component({
  components: {
    BookingSuccess
  }
})
export default class BookingDetail extends Vue {
  @Prop({ default: false })
  isMobile!: boolean;

  @Prop()
  bookingId!: string;

  async goToUpdate() {
    await new UserGoToHelper(this.$router).goToBookingCustomerUpdate(this.bookingId);
  }

  async goToCancel() {
    await new UserGoToHelper(this.$router).goToBookingCustomerCancel(this.bookingId);
  }
}
</script>

<style></style>
